import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReviewHeader from './ReviewHeader';
import ReviewSection from './ReviewSection';
import FilterGroupPanel from './FilterGroupPanel/FilterGroupPanel';
import { strings } from '../../localization';
import MainModuleGroup from '../../components/LayoutTemplateModularFullscreen/MainModuleGroup';
import Analytics from '../../services/analytics';
import Selectors from '../../data/settings/selectors';
import { loadSettings } from '../../data/settings/actions';
import {
    DATE_PICKER_OPTIONS,
    COACHING_REVIEW_EVENTS_SORT_OPTIONS,
    COACHING_REVIEW_EVENTS_SORT_OPTIONS_NO_FACIAL_RECOGNITION,
    DATE_PICKER_OPTIONS_INDEX_FOR_CUSTOM,
    COACHING_REVIEW_EVENTS_DATE_PICKER_OPTIONS,
    DATE_PICKER_OPTIONS_INDEX_FOR_DEFAULT_48_HOUR
} from './Constants';
import { ACTIONS as dispatchActions } from '../../data/layoutTemplateModularFullscreen/duck';


const FLAGGED_EVENT_TO_REAL_EVENTS_MAP = {
  'EVENT_RAVEN_BT_BTN_PRESS': ['EVENT_RAVEN_BT_BTN_SINGLE_PRESS', 'EVENT_RAVEN_BT_BTN_DOUBLE_PRESS', 'EVENT_RAVEN_BT_BTN_SINGLE_PRESS_AND_HOLD', 'EVENT_RAVEN_BT_BTN_DOUBLE_PRESS_AND_HOLD']
};

const getRealEvents = (eventValue) => {
  if (FLAGGED_EVENT_TO_REAL_EVENTS_MAP.hasOwnProperty(eventValue)) {
    return FLAGGED_EVENT_TO_REAL_EVENTS_MAP[eventValue];
  }

  return [eventValue]; // Return as an array for consistent handling
};



export class CoachingFilter extends React.Component {

    constructor(props) {
        super(props);

        const startDatestampDefault = moment().subtract(2, 'days');
        const endDatestampDefault = moment();

        this.state = {
            selectedDateIndex: 2,
            selectedDateRange: [startDatestampDefault.toDate(), endDatestampDefault.toDate()],
            startDate: startDatestampDefault,
            endDate: endDatestampDefault,
            dateOptions: COACHING_REVIEW_EVENTS_DATE_PICKER_OPTIONS.map((option, index) => (index === DATE_PICKER_OPTIONS_INDEX_FOR_DEFAULT_48_HOUR ? { ...option, checked: true } : { ...option, checked: false })),
            sortOptions: this.props.features && this.props.features.facial_recognition ? COACHING_REVIEW_EVENTS_SORT_OPTIONS : COACHING_REVIEW_EVENTS_SORT_OPTIONS_NO_FACIAL_RECOGNITION,
            filterOptionsEvents: [],
            eventTypesFilter: [],
            filterOptionsDriverNames: [],
            driverIdsFilter: [],
            filterOptionsVehicleNames: [],
            vehicleNamesFilter: [],
            filterOptionsFlags: [],
            eventFlagsFilterWithState: [],
            executeQuery: false,
            clearFilterTags: false
        };
    }

    componentDidMount() {
        Analytics.pageView();

        if (!this.props.settingsLoaded) {
            this.props.loadSettings();
        }

        const context = this.props.features && this.props.features.facial_recognition ? "coaching" : "coaching_no_facial_recognition";
        this.setEventsFiltersTypesOptions(document.getEventListForContext(context));
        this.setDriversFiltersNamesOptions(this.props.knownIdentities);
        this.setVehiclesFiltersNamesOptions(this.props.vehicles);
        this.setEventsFiltersFlagsOptions(document.getEventListForContext("coaching_flags"));
    }

    componentDidUpdate(prevProps) {
    }

    onDateRangeSelect = (selectedDateOption) => {

        var selectedDateIndex;

        DATE_PICKER_OPTIONS.forEach((dateOption, dateOptionIndex) => {
            if (dateOption.value === selectedDateOption.value) {
                selectedDateIndex = dateOptionIndex;
            }
        });


        if (isNaN(selectedDateIndex)) {
            console.error("Review date picker configuration error. Unknown selectedDateOption, " + JSON.stringify(selectedDateOption) + ", not found in DATE_PICKER_OPTIONS", DATE_PICKER_OPTIONS);
            return;
        }

        var selectDateOption = DATE_PICKER_OPTIONS[selectedDateIndex];

        var startDatestamp;

        if (selectDateOption.value === 'today') {
            startDatestamp = moment().startOf('day');
        } else if (selectDateOption.value === 'yesterday') {
            startDatestamp = moment().startOf('day').subtract(1, 'days');
        } else if (selectDateOption.value === '24hour') {
            startDatestamp = moment().subtract(1, 'days');
        } else if (selectDateOption.value === '48hour') {
            startDatestamp = moment().subtract(2, 'days');
        } else if (selectDateOption.value === 'week') {
            startDatestamp = moment().subtract(7, 'days');
        } else if (selectDateOption.value === '2weeks') {
            startDatestamp = moment().subtract(14, 'days');
        } else if (selectDateOption.value === 'month') {
            startDatestamp = moment().subtract(31, 'days');
        } else if (selectDateOption.value === 'year') {
            startDatestamp = moment().subtract(365, 'days');
        } else if (selectDateOption.value === 'custom') {
            this.setState({
                selectedDateIndex: selectedDateIndex
            });
            return;
        } else {
            startDatestamp = moment().subtract(3650, 'days');
        }

        const endDate = moment();
        this.setState({
            executeQuery: false,
            selectedDateIndex: selectedDateIndex,
            startDate: startDatestamp,
            endDate: endDate,
            selectedDateRange: [startDatestamp.toDate(), endDate.toDate()]
        });
    }

    setDateOptions = (index) => {

        const options = [...this.state.dateOptions];

        if (index >= options.length) {
            return;
        }

        for (let i = 0; i < options.length; i += 1) {
            if (i === index) {
                options[i].checked = true;
            } else {
                options[i].checked = false;
            }
        }
        this.setState({
            dateOptions: [...options]
        });

        this.onDateRangeSelect(options[index]);
    }

    onCustomDateSelect = (dates) => {
        let startDate = dates.startDate ? dates.startDate : this.state.startDate;
        let endDate = dates.endDate ? dates.endDate : this.state.endDate;

        // When selecting custom dates, ensure they are at the start and end of the day
        startDate = moment(startDate).startOf('day');
        endDate = moment(endDate).endOf('day');
        
        const options = [...this.state.dateOptions];
        for (let i = 0; i < options.length; i += 1) {
            options[i].checked = false;
        }
        options[DATE_PICKER_OPTIONS_INDEX_FOR_CUSTOM].checked = true;
        this.setState({
            dateOptions: [...options]
        });

        this.setState({
            executeQuery: false,
            startDate: startDate,
            endDate: endDate,
            chartError: false,
            selectedDateIndex: DATE_PICKER_OPTIONS_INDEX_FOR_CUSTOM,
            selectedDateRange: [startDate.toDate(), endDate.toDate()]
        });
    }

    onClickSearch = () => {

        if (!this.validateFiltersAreComplete()) return;

        this.setState({
            executeQuery: true
        });

        this.props.setMainModuleGroupNavigation(true);
    }

    onClickClear = () => {
        const startDatestampDefault = moment().subtract(2, 'days');
        const endDatestampDefault = moment();

        this.setState({
            executeQuery: false,
            selectedDateIndex: 2,
            selectedDateRange: [this.state.startDate.toDate(), this.state.endDate.toDate()],
            startDate: startDatestampDefault,
            endDate: endDatestampDefault,
            dateOptions: this.state.dateOptions.map((option, index) => (index === DATE_PICKER_OPTIONS_INDEX_FOR_DEFAULT_48_HOUR ? { ...option, checked: true } : { ...option, checked: false })),
            filterOptionsEvents: this.state.filterOptionsEvents.map(option => ({ ...option, checked: false })),
            filterOptionsDriverNames: this.state.filterOptionsDriverNames.map(option => ({ ...option, checked: false })),
            filterOptionsVehicleNames: this.state.filterOptionsVehicleNames.map(option => ({ ...option, checked: false })),
            filterOptionsFlags: this.state.filterOptionsFlags.map(option => ({ ...option, clickState: 0 })), // default ClickState 0 (blank)
            eventTypesFilter: [],
            driverIdsFilter: [],
            vehicleNamesFilter: [],
            clearFilterTags: true,
        });
    }


    setSortOptions = (index) => {

        const options = [...this.state.sortOptions];

        if (index >= options.length) {
            return;
        }

        for (let i = 0; i < options.length; i += 1) {
            if (i === index) {
                options[i].checked = true;
            } else {
                options[i].checked = false;
            }
        }

        this.setState({
            executeQuery: false,
            sortOptions: [...options]
        });
    }

    onEventsFiltersTypesOptionsSetAll = (isChecked = true, optionalFilterString = undefined) => {

        const options = [...this.state.filterOptionsEvents];
        let eventTypesFilter = [];
        const lowercasedFilterString = optionalFilterString ? optionalFilterString.toLocaleLowerCase() : undefined;
        options.forEach((option) => {
            if (isChecked && lowercasedFilterString) {
                const lowercasedOptionLabel = option.label.toLowerCase();
                if (lowercasedOptionLabel.indexOf(lowercasedFilterString) === -1) {
                    option.checked = false;
                } else {
                    option.checked = isChecked;
                    eventTypesFilter.push(...getRealEvents(option.value));
                }
            } else {
                option.checked = isChecked;
                if (isChecked) eventTypesFilter.push(...getRealEvents(option.value));
            }
        });

        this.setState({
            executeQuery: false,
            filterOptionsEvents: [...options],
            eventTypesFilter: eventTypesFilter
        });
    }

    onDriversFiltersNamesOptionsSetAll = (isChecked = true, optionalFilterString = undefined) => {
        const options = [...this.state.filterOptionsDriverNames];
        let driverIdsFilter = [];
        const lowercasedFilterString = optionalFilterString ? optionalFilterString.toLocaleLowerCase() : undefined;
        options.forEach((option) => {
            if (isChecked && lowercasedFilterString) {
                const lowercasedOptionLabel = option.label.toLowerCase();
                if (lowercasedOptionLabel.indexOf(lowercasedFilterString) === -1) {
                    option.checked = false;
                } else {
                    option.checked = isChecked;
                    driverIdsFilter.push(option.value);
                }
            } else {
                option.checked = isChecked;
                if (isChecked) driverIdsFilter.push(option.value);
            }
        });
        this.setState({
            executeQuery: false,
            filterOptionsDriverNames: [...options],
            driverIdsFilter: driverIdsFilter
        });
    }

    onVehiclesFiltersNamesOptionsSetAll = (isChecked = true, optionalFilterString = undefined) => {
        const options = [...this.state.filterOptionsVehicleNames];
        let vehicleNamesFilter = [];
        const lowercasedFilterString = optionalFilterString ? optionalFilterString.toLocaleLowerCase() : undefined;
        options.forEach((option) => {
            if (isChecked && lowercasedFilterString) {
                const lowercasedOptionLabel = option.label.toLowerCase();
                if (lowercasedOptionLabel.indexOf(lowercasedFilterString) === -1) {
                    option.checked = false;
                } else {
                    option.checked = isChecked;
                    vehicleNamesFilter.push(option.value);
                }
            } else {
                option.checked = isChecked;
                if (isChecked) vehicleNamesFilter.push(option.value);
            }
        });
        this.setState({
            executeQuery: false,
            filterOptionsVehicleNames: [...options],
            vehicleNamesFilter: vehicleNamesFilter
        });
    }

    onEventsFiltersTypesOptionSelect = (index, forceCheckedValue = undefined) => {

        const options = [...this.state.filterOptionsEvents];

        if (index >= options.length) {
            return;
        }

        if (forceCheckedValue === undefined) {
            options[index].checked = !options[index].checked;
        } else {
            options[index].checked = forceCheckedValue;
        }

        let eventTypesFilter = [];

        options.forEach((filterOption) => {
            if (filterOption.checked) {
                eventTypesFilter.push(...getRealEvents(filterOption.value));
            }
        });

        this.setState({
            executeQuery: false,
            filterOptionsEvents: [...options],
            eventTypesFilter: eventTypesFilter,
        });
    };

    setEventsFiltersTypesOptions = (eventTypes) => {

        if (!eventTypes) {
            console.warn("Coaching ReviewHeader setEventsFiltersTypesOptions event.detail.eventTypes not found.");
            return;
        }

        let eventTypesFilterOptions = [];
        let eventTypesFilter = [];
        eventTypes.forEach((eventType) => {

            const prexistingPreference = this.state.filterOptionsEvents.find((eventTypePreference) => {
                return eventTypePreference.value === eventType;
            });

            let checked = prexistingPreference ? prexistingPreference.checked : false
            eventTypesFilterOptions.push({
                value: eventType,
                label: document.getEventName({ type: eventType }),
                checked: checked
            });
            if (checked) eventTypesFilter.push(...getRealEvents(eventType));
        });
        this.setState({
            filterOptionsEvents: eventTypesFilterOptions,
            eventTypesFilter: eventTypesFilter
        });
    };

    onDriversFiltersNamesOptionSelect = (index, forceCheckedValue = undefined) => {

        const options = [...this.state.filterOptionsDriverNames];

        if (index >= options.length) {
            return;
        }

        if (forceCheckedValue === undefined) {
            options[index].checked = !options[index].checked;
        } else {
            options[index].checked = forceCheckedValue;
        }


        let driverIdsFilter = [];

        options.forEach((filterOption) => {
            if (filterOption.checked) {
                driverIdsFilter.push(filterOption.value);
            }
        });

        this.setState({
            executeQuery: false,
            filterOptionsDriverNames: [...options],
            driverIdsFilter: driverIdsFilter
        });
    };

    setDriversFiltersNamesOptions = (knownIdentities) => {

        if (!knownIdentities) {
            console.warn("Coaching ReviewHeader setDriversFiltersNamesOptions event.detail.driverNames not found.");
            return;
        }

        let driverNamesFilterOptions = [];
        let driverIdsFilter = [];
        let preexistingUnknownDriverFound = false;
        knownIdentities.forEach((driverIdentity) => {

            const prexistingPreference = this.state.filterOptionsDriverNames.find((driverNamePreference) => {
                return driverNamePreference.value === driverIdentity.identityId;
            });

            let checked = prexistingPreference ? prexistingPreference.checked : false
            if (prexistingPreference && prexistingPreference.value === null) {
                preexistingUnknownDriverFound = true;
            }

            driverNamesFilterOptions.push({
                value: driverIdentity.identityId,
                label: driverIdentity.name,
                checked: checked
            });

            if (checked) driverIdsFilter.push(driverIdentity.identityId);

        });

        if (!preexistingUnknownDriverFound) {
            driverNamesFilterOptions.push({
                value: null,
                label: strings.unknown,
                checked: false
            });
            //driverIdsFilter.push(null); uncomment if default checked value is "true"
        }

        this.setState({
            filterOptionsDriverNames: driverNamesFilterOptions,
            driverIdsFilter: driverIdsFilter
        });
    };

    onVehiclesFiltersNamesOptionSelect = (index, forceCheckedValue = undefined) => {

        const options = [...this.state.filterOptionsVehicleNames];

        if (index >= options.length) {
            return;
        }

        if (forceCheckedValue === undefined) {
            options[index].checked = !options[index].checked;
        } else {
            options[index].checked = forceCheckedValue;
        }

        let vehicleNamesFilter = [];

        options.forEach((filterOption) => {
            if (filterOption.checked) {
                vehicleNamesFilter.push(filterOption.value);
            }
        });

        this.setState({
            executeQuery: false,
            filterOptionsVehicleNames: [...options],
            vehicleNamesFilter: vehicleNamesFilter
        });
    };

    onTagsFilterOptionsSelect = (selectedTagsIds) => {

        if(selectedTagsIds.length === 0) {
            this.setVehiclesFiltersNamesOptions(this.props.vehicles, false);
            return;
        }

        const vehicles = this.props.vehicles.filter((vehicle) => {
            return vehicle.tags.some((tag) => {
                return selectedTagsIds.includes(tag);
            });
        });
        this.setVehiclesFiltersNamesOptions(vehicles, true);
    }

    setVehiclesFiltersNamesOptions = (vehicles, isFilterByTags = false) => {

        if (!vehicles) {
            console.warn("Coaching ReviewHeader setVehiclesFiltersNamesOptions event.detail.vehicleNames not found.");
            return;
        }

        let vehicleNamesFilterOptions = [];
        let vehicleNamesFilter = [];
        vehicles.forEach( (vehicle) => {

            const prexistingPreference = this.state.filterOptionsVehicleNames.find((vehicleNamePreference) => {
                return vehicleNamePreference.value === vehicle.name;
            });

            let checked = isFilterByTags ? true : prexistingPreference ? prexistingPreference.checked : false
            vehicleNamesFilterOptions.push({
                value: vehicle.name,
                label: vehicle.name,
                checked: checked
            });
            if (checked) vehicleNamesFilter.push(vehicle.name);
        });

        this.setState({
            executeQuery: false,
            filterOptionsVehicleNames: vehicleNamesFilterOptions,
            vehicleNamesFilter: vehicleNamesFilter
        });
    };

    onEventsFiltersFlagsOptionSelect = (index, forceClickState = undefined) => {

        const options = [...this.state.filterOptionsFlags];

        if (index >= options.length) {
            return;
        }

        if (forceClickState === undefined) {
            options[index].clickState = (options[index].clickState + 1) % 3;
        } else {
            options[index].clickState = forceClickState;
        }

        let eventFlagsFilterWithState = [];

        options.forEach((filterOption) => {
            if (filterOption.clickState === 1 || filterOption.clickState === 2) { // include flags with include (1) and exclude state (2) for filtering
                eventFlagsFilterWithState.push({ [filterOption.value]: filterOption.clickState });
            }
        });

        this.setState({
            executeQuery: false,
            filterOptionsFlags: [...options],
            eventFlagsFilterWithState: eventFlagsFilterWithState,
        });
    };

    setEventsFiltersFlagsOptions = (eventFlags) => {

        if (!eventFlags) {
            console.warn("Coaching ReviewHeader setEventsFiltersFlagsOptions event.detail.eventFlags not found.");
            return;
        }

        let eventFlagsFilterOptions = [];
        let eventFlagsFilterWithState = [];
        eventFlags.forEach((eventFlag) => {

            const prexistingPreference = this.state.filterOptionsFlags.find((eventFlagPreference) => {
                return eventFlagPreference.value === eventFlag;
            });

            let clickState = prexistingPreference ? prexistingPreference.clickState : 0; // if prexistingPreference is undefined, set clickState to 0 (accept true or false flag state)
            eventFlagsFilterOptions.push({
                value: eventFlag,
                label: document.getEventFlagName({ type: eventFlag }),
                clickState: clickState
            });
            if (clickState === 1 || clickState === 2) eventFlagsFilterWithState.push({ [eventFlag]: clickState }); // if flag state is true (1) include that flag state in filter list
        });
        this.setState({
            filterOptionsFlags: eventFlagsFilterOptions,
            eventFlagsFilterWithState: eventFlagsFilterWithState
        });
    };

    validateFiltersAreComplete = () => {
        if (this.state.eventTypesFilter.length === 0) {
            return false;
        }
        if (this.state.vehicleNamesFilter.length === 0) {
            return false;
        }

        if (this.props.features.facial_recognition && // env and account config
            this.props.facialRecognitionEnabled && // account settings, if available (RAV-4218, if user disables FR, omit the filter)
            this.state.filterOptionsDriverNames && // driver names from Reporting API
            this.state.filterOptionsDriverNames.length > 1 && // driver names contains more than just "Unknown" option (RAV-4468 if FR enabled/disabled state cannot be determined than check filter length)
            this.state.driverIdsFilter.length === 0) {
            return false;
        }

        return true;
    }


    render() {
        if (!this.props.user) return null;

        const filtersAreComplete = this.validateFiltersAreComplete();

        const allEventTypesSelected = this.state.filterOptionsEvents.length > 0 && this.state.filterOptionsEvents.every(opt => opt.checked);

        const noFiltersSelected = this.state.eventTypesFilter.length === 0 && this.state.driverIdsFilter.length === 0 && this.state.vehicleNamesFilter.length === 0 && this.state.eventFlagsFilterWithState.length === 0;
        return (
            <MainModuleGroup
                mainModuleGroupNavigation={
                    <FilterGroupPanel
                        {...this.props}
                        eventTypes={document.getEventListForContext("coaching")}
                        eventFlags={document.getEventListForContext("coaching_flags")}
                        selectedDateIndex={this.state.selectedDateIndex}
                        selectedDateRange={this.state.selectedDateRange}
                        onDateRangeSelect={this.onDateRangeSelect}
                        onCustomDateSelect={this.onCustomDateSelect}
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        sortOptions={this.state.sortOptions}
                        dateOptions={this.state.dateOptions}
                        setSortOptions={this.setSortOptions}
                        setDateOptions={this.setDateOptions}
                        filterOptionsEvents={this.state.filterOptionsEvents}
                        onEventsFiltersTypesOptionSelect={this.onEventsFiltersTypesOptionSelect}
                        onEventsFiltersTypesOptionsSetAll={this.onEventsFiltersTypesOptionsSetAll}
                        filterOptionsDriverNames={this.state.filterOptionsDriverNames}
                        onDriversFiltersNamesOptionSelect={this.onDriversFiltersNamesOptionSelect}
                        onDriversFiltersNamesOptionsSetAll={this.onDriversFiltersNamesOptionsSetAll}
                        filterOptionsVehicleNames={this.state.filterOptionsVehicleNames}
                        onVehiclesFiltersNamesOptionSelect={this.onVehiclesFiltersNamesOptionSelect}
                        onVehiclesFiltersNamesOptionsSetAll={this.onVehiclesFiltersNamesOptionsSetAll}
                        filterOptionsFlags={this.state.filterOptionsFlags}
                        onEventsFiltersFlagsOptionSelect={this.onEventsFiltersFlagsOptionSelect}
                        onEventsFiltersFlagsOptionsSetAll={this.onEventsFiltersFlagsOptionsSetAll}
                        onClickSearch={this.onClickSearch}
                        onClickClear={this.onClickClear}
                        clearFilterTags={this.state.clearFilterTags}
                        resetClearFilterTags={() => this.setState({ clearFilterTags: false })}
                        applyIsDisabled={this.state.executeQuery || !filtersAreComplete}
                        clearIsDisabled={noFiltersSelected}

                        onTagsFilterOptionsSelect={this.onTagsFilterOptionsSelect}
                    />
                }
                mainModuleGroup={
                    <div className="event-review-page">
                        <ReviewHeader
                            {...this.props}
                            sortOptions={this.state.sortOptions}
                            selectedDateIndex={this.state.selectedDateIndex}
                            allEventTypesSelected={allEventTypesSelected}
                            executeQuery={this.state.executeQuery}
                        />
                        <ReviewSection
                            {...this.props}
                            selectedDateRange={this.state.selectedDateRange}
                            sortOptions={this.state.sortOptions}
                            setSortOptions={this.setSortOptions}
                            eventTypesFilter={this.state.eventTypesFilter}
                            driverIdsFilter={this.state.driverIdsFilter}
                            vehicleNamesFilter={this.state.vehicleNamesFilter}
                            eventFlagsFilterWithState={this.state.eventFlagsFilterWithState}
                            executeQuery={this.state.executeQuery}
                        />
                    </div>
                }
            />
        );
    }
};

CoachingFilter.propTypes = {
    settingsLoaded: PropTypes.bool.isRequired,
    user: PropTypes.object.isRequired,
    loadSettings: PropTypes.func.isRequired,
    facialRecognitionEnabled: PropTypes.bool,
    tags: PropTypes.array,
    tagsLoaded: PropTypes.bool,
    tagsError: PropTypes.object,
    tagsLoading: PropTypes.bool,
    unitOfMeasure: PropTypes.string,
    settingsError: PropTypes.object,
    setMainModuleGroupNavigation: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => {
    return {
        settingsLoaded: Selectors.settingsLoaded(state),
        unitOfMeasure: Selectors.unitOfMeasure(state),
        settingsError: Selectors.error(state),
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        loadSettings: () => dispatch(loadSettings(ownProps.user.stage)),
        setMainModuleGroupNavigation: (isCollapsed) => dispatch(dispatchActions.setMainModuleGroupNavigation(isCollapsed))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CoachingFilter);
